/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_EmailInputs */

const fr_legal_email = /** @type {(inputs: Legal_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail :`)
};

const en_legal_email = /** @type {(inputs: Legal_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

/**
* | output |
* | --- |
* | "Email:" |
*
* @param {Legal_EmailInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_email = /** @type {((inputs?: Legal_EmailInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_EmailInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_email(inputs)
	return en_legal_email(inputs)
});